import React from 'react';
import { Form, Input } from 'antd';

export class PasswordComponent extends React.Component {
  render() {
    const {getFieldDecorator} = this.props.form;
    const {name, label, placeholder, rules, value,} = this.props.values;

    return (
      <Form.Item className="no-bottom-margin" label={label}>
        {getFieldDecorator(name, {
          rules: rules,
          initialValue: value,
        })(<Input.Password placeholder={placeholder} />)}
      </Form.Item>
    );
  }
}
